import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { authRoles } from "../../../auth/authRoles";

const DtJudgementTable = Loadable(lazy(() => import("../caseLaw/App")));
const StatutesTable = Loadable(lazy(() => import("../statutes/App")));
const ActsTable = Loadable(lazy(() => import("../acts/App")));
const RulesTable = Loadable(lazy(() => import("../rules/App")));
const KnowledgeTable = Loadable(lazy(() => import("../knowledge/App")));

const directTaxRoutes = [
  { path: "/cl/judgements", element: <DtJudgementTable />, auth: authRoles.guest},
  { path: "/cl/judgements/:id/*", element: <DtJudgementTable />, auth: authRoles.guest },
  { path: "/cl/statutes", element: <StatutesTable />, auth: authRoles.guest},
  { path: "/cl/statutes/:id/*", element: <StatutesTable />, auth: authRoles.guest },
  { path: "/cl/acts", element: <ActsTable />, auth: authRoles.guest},
  { path: "/cl/acts/:id/*", element: <ActsTable />, auth: authRoles.guest },
  { path: "/cl/rules", element: <RulesTable />, auth: authRoles.guest},
  { path: "/cl/rules/:id/*", element: <RulesTable />, auth: authRoles.guest },
  { path: "/cl/knowledge", element: <KnowledgeTable />, auth: authRoles.guest},
  { path: "/cl/knowledge/:id/*", element: <KnowledgeTable />, auth: authRoles.guest },
];

export default directTaxRoutes;
